/* PD « Complétez son look » : gère les boutons « + Ajouter » des cartes :
   ajout au panier en AJAX sans quitter la fiche, choix de couleur pré-réglé sur la couleur la plus
   proche de celle choisie pour la robe, puis mise à jour du mini-panier et du compteur. */
(function () {
  // Couleur choisie sur la fiche (nom + teinte de la pastille)
  function productColor(look) {
    const fp = look.closest('[data-pd-fp]');
    const checked = fp && fp.querySelector('.pd-fp__option--color .pd-fp__radio:checked');
    if (!checked) return null;
    const label = fp.querySelector(`label[for="${checked.id}"]`);
    const hex = label ? label.style.getPropertyValue('--swatch') : '';
    return { name: checked.value, hex };
  }

  function preselect(panel, look) {
    // Couleur la plus proche de la robe : logique partagée avec le tiroir panier (pd-color.js)
    const radios = [...panel.querySelectorAll('.pd-quick__radio:not(:disabled)')];
    const pick = window.PdColor && window.PdColor.closest(radios, productColor(look));
    if (pick) pick.checked = true;
    updateValue(panel);
  }

  function updateValue(panel) {
    const checked = panel.querySelector('.pd-quick__radio:checked');
    const value = panel.querySelector('[data-pd-quick-value]');
    if (checked && value) value.textContent = checked.dataset.name;
  }

  function closePanel(quick, focusButton) {
    const panel = quick.querySelector('[data-pd-quick-panel]');
    const opener = quick.querySelector('[data-pd-quick-open]');
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    quick.closest('.pd-carrousel__card').classList.remove('is-choosing');
    opener.setAttribute('aria-expanded', 'false');
    if (focusButton) opener.focus();
  }

  function openPanel(quick, look) {
    look.querySelectorAll('[data-pd-quick]').forEach((other) => {
      if (other !== quick) closePanel(other, false);
    });
    const panel = quick.querySelector('[data-pd-quick-panel]');
    preselect(panel, look);
    panel.hidden = false;
    quick.closest('.pd-carrousel__card').classList.add('is-choosing');
    quick.querySelector('[data-pd-quick-open]').setAttribute('aria-expanded', 'true');
    const focusTarget = panel.querySelector('.pd-quick__radio:checked') || panel.querySelector('[data-pd-quick-add]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  async function refreshCart(sections) {
    const html = sections && sections['minicart-form'];
    const target = document.getElementById('minicart-form');
    if (html && target) {
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
      if (fresh) target.innerHTML = fresh.innerHTML;
    }
    try {
      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)).json();
      document.querySelectorAll('.cart-count').forEach((el) => {
        el.innerHTML = el.classList.contains('cart-count-drawer')
          ? `(${cart.item_count})`
          : cart.item_count > 100
          ? '~'
          : cart.item_count;
      });
      const total = document.querySelector('header-total-price');
      if (total && typeof total.updateTotal === 'function') total.updateTotal(cart);
      const freeShip = document.querySelector('free-ship-progress-bar');
      if (freeShip && typeof freeShip.init === 'function') freeShip.init(cart.items_subtotal_price);
    } catch (error) {
      // Le compteur se remettra à jour au prochain chargement de page
    }
  }

  async function addToCart(quick, look) {
    const trigger = quick.querySelector('[data-pd-quick-open]') || quick.querySelector('[data-pd-quick-add]');
    const confirm = quick.querySelector('[data-pd-quick-add]');
    const checked = quick.querySelector('.pd-quick__radio:checked');
    const variantId = checked ? checked.value : confirm.dataset.variantId;
    const status = quick.querySelector('[data-pd-quick-status]');
    if (!variantId || quick.classList.contains('is-loading')) return;

    quick.classList.add('is-loading');
    confirm.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: 'minicart-form',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || '');

      closePanel(quick, false);
      await refreshCart(data.sections);
      const addedText = `${look.dataset.addedLabel}${checked ? ` : ${checked.dataset.name}` : ''}`;
      status.textContent = addedText;
      trigger.classList.add('is-added');
      trigger.dataset.label = trigger.dataset.label || trigger.innerHTML;
      trigger.innerHTML = `<svg class="pd-quick__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2.5 8.5l3.5 3.5 7.5-8"/></svg>${look.dataset.addedLabel}`;
      clearTimeout(trigger.pdQuickTimer);
      trigger.pdQuickTimer = setTimeout(() => {
        trigger.innerHTML = trigger.dataset.label;
        trigger.classList.remove('is-added');
      }, 2500);
      trigger.focus({ preventScroll: true });
    } catch (error) {
      const errorBox = quick.querySelector('[data-pd-quick-error]');
      errorBox.textContent = error.message || look.dataset.errorLabel;
      errorBox.hidden = false;
      clearTimeout(errorBox.pdQuickTimer);
      errorBox.pdQuickTimer = setTimeout(() => {
        errorBox.hidden = true;
      }, 5000);
    } finally {
      quick.classList.remove('is-loading');
      confirm.removeAttribute('aria-busy');
    }
  }

  function initLook(look) {
    if (look.dataset.pdLookReady) return;
    look.dataset.pdLookReady = 'true';

    look.addEventListener('click', (event) => {
      const quick = event.target.closest('[data-pd-quick]');
      if (!quick) return;
      if (event.target.closest('[data-pd-quick-open]')) {
        const panel = quick.querySelector('[data-pd-quick-panel]');
        if (panel.hidden) openPanel(quick, look);
        else closePanel(quick, true);
      } else if (event.target.closest('[data-pd-quick-close]')) {
        closePanel(quick, true);
      } else if (event.target.closest('[data-pd-quick-add]')) {
        addToCart(quick, look);
      }
    });

    look.addEventListener('change', (event) => {
      const panel = event.target.closest('[data-pd-quick-panel]');
      if (panel) updateValue(panel);
    });

    look.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const quick = event.target.closest('[data-pd-quick]');
      if (quick) closePanel(quick, true);
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-pd-quick]')) return;
      look.querySelectorAll('[data-pd-quick]').forEach((quick) => closePanel(quick, false));
    });
  }

  const initAll = (scope) => scope.querySelectorAll('[data-pd-look]').forEach(initLook);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
